import { useMemo } from 'react'

import { isPolicyRenewalBound, Policy, PolicyStatus } from '../../../../../domain'
import {
  getFeatureToggles,
  ProductConfig,
  useConfig,
} from '../../../../../state/configuration'
import { billing, claims, documents, policyDetails } from './tabs'
import { TabItem } from './types'

export const useTabs = (policy: Policy, product: ProductConfig): TabItem[] => {
  const { hideBilling } = useConfig(getFeatureToggles)

  return useMemo(() => {
    let tabLoaders = (() => {
      switch (policy.policyDetail.policyStatus) {
        case PolicyStatus.ACTIVE:
          return isPolicyRenewalBound(policy)
            ? [documents, billing, claims]
            : [policyDetails, documents, billing, claims]
        case PolicyStatus.PENDING:
          return [policyDetails, documents, billing, claims]
        case PolicyStatus.CANCELLED:
        case PolicyStatus.LAPSED:
          return [billing, claims]
        case PolicyStatus.VOIDED:
        case PolicyStatus.NTU:
          return [billing]
        case PolicyStatus.RENEWED:
          throw new Error(
            `Cannot show policy ${policy.policyId} as it is in status RENEWED`,
          )
      }
    })()

    if (hideBilling) {
      tabLoaders = tabLoaders.filter((tab) => tab !== billing)
    }

    return tabLoaders.map((tab) => tab(product)).filter(Boolean) as TabItem[]
  }, [policy, product])
}
